export const toLowerCase = <T>(str?: string) =>
  str ? (str.toLowerCase() as T) : undefined;
